import { Component, Input, OnInit, ViewEncapsulation, SimpleChanges, ChangeDetectorRef, NgZone, inject, Output, EventEmitter, ViewChild, TemplateRef } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import * as moment from 'moment';
import { MessageService } from 'src/app/services/message.service';
import { AlertService, CommonService, DocumentsService, ErxService, ModalWrapperService } from 'src/app/services';
import { Subject, Subscription } from 'rxjs';
import { MessagesHistory } from 'src/app/models/messaging-model';
import { IdentifierTypeEnum, Message} from 'src/app/models/messaging.enum';
import { takeUntil } from 'rxjs/operators';
import { WebPubSubService } from 'src/app/services/WebPubSubService';
import { constant } from 'src/app/app.constants';
import { MsgConfig } from 'src/app/app.messages';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Documents, EPatient, OrganizationRequest, SharedDocuments } from 'src/app/models';
import { CommonUtil, NewAuditUtils } from 'src/app/utils';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PatientCategoryService } from "./../../../services/patient-category.service";

@Component({
  selector: 'app-spc-chat-history',
  templateUrl: './spc-chat-history.component.html',
  styleUrls: ['./spc-chat-history.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class SpcChatHistoryComponent implements OnInit {
  @Input() messages: any[] = [];
  @Input() enterMessage: any[] = [];
  @Input() dataSource: any[] = [];
  filteredMessages: Message[] = [];
  fetchedMessages: Message[] = [];
  groupedMessages: any[] = [];
  @Input() patientID: any;
  @Input() userName: any;
  @Input() resetMessages:any;
  @Input() searchHistoryText: string = '';
  isnewMsgReceived:boolean = false;
  pharmacyName:any;
  pharmacyMessages:any;
  patientMessages:any;
  private messageSubscription: Subscription;
  unsubscribe$: Subject<void> = new Subject();
  auth0_token:any;
  npi:any;
  openTrnsReqPopup: boolean;
  rxPatientModel: EPatient;
  drugId: any;
  drugInformation: {};
  transferPharmacyNPI: string;
  sourcePharmacyDetails: any;
  private _cmnUtil = inject(CommonUtil);
    imageUrlMap: any
  historyPreviewUrl: string;
  isHistoryPreviewOpen: boolean;
   @Output() sharedImagesChange = new EventEmitter<string[]>();
  previewDrugName: string;
  previewFilename: any;
  zoom: number = 1;
  today: string = moment().format('MM/DD/YYYY');
  docUploadFG: FormGroup;
  subCatDropdownsList: any[] = [];
  subCatDropdowns: any[] = [];
  functionScreen: string = 'PATIENT';       // label only
  formGroupInvalid = false;
  editMode = false;
  addFileType: 'image' | 'pdf' | null = null;
  uploadedFile: File | null = null;
  src: any;
  innerHtml: any;
  modalRef: any;
  selectedSaveTo: string = 'patient';  // Default to Patient
  rxQuery: string = '';
  rxList: any[] = [];
  selectedRx: any = null;
  showDropdown: boolean = false;
zoomLevel: number = 100;
@Input() isFrmMessegingTab: any;
@ViewChild('chatDocTpl', { static: false }) chatDocTpl: TemplateRef<any>;
  showEditImage: boolean;
  sizeInBytes: number;
  showRxandDrugDetails: boolean;
  previewDtTm: any;
  sizeInMB: number;
  previewSize: string;
  noRxFound: boolean;
  previewDoc: any;
  _commonUtil = inject(CommonUtil);
  @Input() ProfilePicDocId: any;
  @Output() profilePicUrlChange = new EventEmitter<string>();
  validDocIds: string[] = [];
  constructor(
    private _msgServ: MessageService,
    private _userServ: UserService,
    private _commonServ: CommonService,
    private _cdr: ChangeDetectorRef,
    private _webPubSubService: WebPubSubService,
    private _ngZone: NgZone,
    private sanitizer: DomSanitizer,
    private _eRxService: ErxService, private modalService: ModalWrapperService,
  private _fb: FormBuilder,
  private _docService: DocumentsService,  private _patCatServ: PatientCategoryService, private _alertService: AlertService,private _NewAuditUtils: NewAuditUtils) { }
    

  ngOnInit() {
    this.pharmacyName = this._userServ.getToken("PharmacyName");
    this.npi = this._userServ.getToken("UniquePharmacyId");
    if (this.isValidPatientAndNpi()) {   
      this.loadMessages(); 
    }
    this.messageSubscription = this._webPubSubService.newMessage$.subscribe((res) => {
        if(res) {
          if (res?.Sender?.Identifier === this.patientID) {
            this.isnewMsgReceived = true;
            const newMessage = {
                date: res?.MessageReceivedAt,
                message: res?.MessageText,
                isRead: false,
                sender: {
                  type: 0,
                  identifier: res?.Sender?.Identifier,
                  identifierType: IdentifierTypeEnum.PATIENT,
                  userName: this.userName ? this.userName : ''
                },
                recipient: {
                  type: 0,
                  identifier: res?.Recipient?.Identifier,
                  identifierType: IdentifierTypeEnum.NPI,
                  userName: this.pharmacyName
                }
              };
              this.messages = [...this.messages, newMessage];    
              const uniqueMessages = Array.from(new Map(
                  this.messages.map(msg => [`${msg.message}-${msg.date}`, msg])
              ).values());   
              this.messages = uniqueMessages;
              this.sortMessages();
              this.groupMessagesByDate();
              this.filteredMessages = [...this.messages];
              this._ngZone.runOutsideAngular(() => {
              requestAnimationFrame(() => {
                this.isnewMsgReceived = false;
                this.scrollToBottom();
              });
              this._cdr.markForCheck();
            });
        }
      }
    });
  this.createDocFG();
  this.getSubCatsForPatient();
}

groupMessagesByDate(): void {
    const groupedMessages: any[] = [];
    const today = moment().startOf('day');
    const yesterday = moment().subtract(1, 'day').startOf('day');
    const startOfWeek = moment().startOf('week'); 
    this.messages.forEach(msg => {
    const msgDate = moment(msg.date); 
    if(!msgDate.isValid()) {
        console.log('Invalid date format:', msg.date); 
        return; 
    }
    const msgDay = msgDate.startOf('day');
    let header = '';
    if (msgDay.isSame(today)) {
        header =  MsgConfig.Today;
    } else if (msgDay.isSame(yesterday)) {
        header = MsgConfig.Yesterday
    } else if (msgDay.isBetween(startOfWeek, today, undefined, '[)')) {
        header = msgDay.format('dddd'); 
    } else {
        header = msgDay.format('dddd, MMMM D'); 
    }
    if(!groupedMessages.some(g => g.isHeader && g.date === header)) {
        groupedMessages.push({ isHeader: true, date: header });
    } 
        groupedMessages.push(msg);
    }); 
    this.groupedMessages = groupedMessages;
    this._cdr.markForCheck();
}
private isValidPatientAndNpi(): boolean {
  return !!this.patientID && !!this.npi;
}
  
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['searchHistoryText']) {
        this.filterMessages();
    }
    if (changes.patientID || changes.npi || changes?.resetMessages?.currentValue) {
      if (this.isValidPatientAndNpi()) {
          this._cdr.detectChanges();
          if(!this.isnewMsgReceived && this.resetMessages){
            this.loadMessages(); 
          }
      }
    }
    
    if (changes['enterMessage'] && changes['enterMessage'].currentValue) {
        const incomingMessages = changes['enterMessage'].currentValue;
        if (incomingMessages.length > 0) {

            this.messages = [...this.messages, ...incomingMessages];
            const uniqueMessages = Array.from(new Map(
                this.messages.map(msg => [`${msg.message}-${msg.date}`, msg])
            ).values());
            this.messages = uniqueMessages;
            this.messages.forEach(msg => {
              if (msg?.sender?.userName) {
                msg.sender.userName = this.capitalizeName(msg.sender.userName);
              }
              msg.status = msg.status?.toLowerCase();
            });
            this.sortMessages();
            this.groupMessagesByDate();
            this._ngZone.runOutsideAngular(() => {
                requestAnimationFrame(() => {
                    this.scrollToBottom();
                });
            });
        }
      }
  }
  filterMessages(): void {
    const searchLower = this.searchHistoryText.toLowerCase(); 

    this.messages = this.filteredMessages.filter(m => { 
        const matchesSearch = m.message.toLowerCase().includes(searchLower);
        return matchesSearch;
    });
    if (!searchLower) { 
        this.messages = [...this.filteredMessages];
    } else {
        this.messages = this.filteredMessages.filter(m => 
            m.message.toLowerCase().includes(searchLower)
        );
    } 
    this.messages.forEach(msg => {
        if(msg?.sender?.userName) {
            msg.sender.userName = this.capitalizeName(msg?.sender?.userName);
        }
        msg.status = msg.status?.toLowerCase();
    }); 
    this.sortMessages();
    this.groupMessagesByDate();
    this._ngZone.runOutsideAngular(() => {
        requestAnimationFrame(() => {
            this.scrollToBottom();
        });
    });
}
  onScroll(event: any) {
    const element = event.target;
    if (element.scrollTop === 0) { 
      if (this.isValidPatientAndNpi()) { 
        //this.loadMessages();
      }
    } else if (element.scrollHeight - element.scrollTop === element.clientHeight) {
      this.loadMoreMessages(); 
    }
  }

  loadMoreMessages() { 
    // Lazy load more history data (scroll Down)
  }
  initiateTransfer(drugId: string, pharmacyName: string, pharmacyNPI: string) {
    this.drugId = drugId;
    this.transferPharmacyNPI = pharmacyNPI;
    this.getInfo();
    this.openTrnsReqPopup = true;
  }

parseMessage(message: string): SafeHtml {
    const safeText = this.escapeHtml(message);
    return this.sanitizer.bypassSecurityTrustHtml(safeText);
}
parseMessagefromPh(message: string): SafeHtml {
  const visible = (message || '').split('~&~')[0] || '';
  const withoutUrls = visible.replace(/((https?:\/\/|www\.)\S+)/gi, '').trim();
  return this.sanitizer.bypassSecurityTrustHtml(this.escapeHtml(withoutUrls));
}

  getTransferData(message: string) {
    const visibleMessage = message?.split('~&~')[0]?.trim() || '';
    const hiddenMessage = message?.split('~&~')[1]?.trim() || '';
    let drugName = '';
    let pharmacyName = '';
    let drugId = '';
    let pharmacyNPI = '';
    const match = visibleMessage?.match(/for\s+(.*?)\s+from\s+(.*)/i);
    if (match && match.length === 3) {
      drugName = match[1].trim();
      pharmacyName = match[2].trim().replace(/\.$/, '');
      const drugIdMatch = hiddenMessage.match(/DrugId=(\d+)/);
      drugId = drugIdMatch ? drugIdMatch[1] : '';
      const pharmacyIdMatch = hiddenMessage.match(/SourcePharmacyNPI=(\d+)/);
      pharmacyNPI = pharmacyIdMatch ? pharmacyIdMatch[1] : '';
    }
    return { drugName, pharmacyName, drugId, pharmacyNPI };
  }

    escapeHtml(text: string): string {
      const div = document.createElement('div');
      div.innerText = text;
      return div.innerHTML;
    }

    async getInfo() {
      if(this.patientID){
        const resp = await this._commonServ.getRxPatientDetailsById(this.patientID).toPromise();
        if(resp){
          this.rxPatientModel = resp;
        }
      }
      if(this.drugId){
      this._commonServ.getDrugInfo(this.drugId).subscribe((resp)=>{
        if(resp && resp.Drug){
          this.drugInformation = this.generateGridData(resp.Drug);
        }
      });
      if(this.transferPharmacyNPI){
        this.searchPharmacy(this.transferPharmacyNPI);
      }
    }
  }
  
  searchPharmacy(event) {
    const modelData = this._commonUtil.getOrganizationRequestForPharmSuggest(event);
    if (modelData) {
      this._eRxService.toGetTranferPharListWithServiceAvail(modelData).subscribe((pharmacies) => {
        if (pharmacies) {
          this.sourcePharmacyDetails = pharmacies?.[0];
        }
      });
    }
  }

  generateGridData(drug) {
  if (drug) {
    let j = {};
    j["drugname"] = drug?.Name;
    j["strength"] = drug?.Strength;
    j["drugformname"] = drug?.DrugFormName;
    j["drugclass"] = drug?.DrugClass;
    j["ndc"] = drug.DrugCode;
    j["isbranded"] = drug?.IsBranded;
    j["qtypack"] = drug?.QtyPack;
    j["manufacturername"] = drug?.ManufactName;
    j["unitpriceawp"] = drug?.UnitPriceAWP;
    j["unitpricecost"] = drug?.UnitPriceCost;
    j["id"] = drug?.Id;
    return j;
  }
  return null;
  }
isTransferCardMessage(msg: string): boolean {
  const hidden = msg?.split('~&~')[1]?.trim() || '';
  return !!hidden && !hidden.startsWith('img:');
}

  closeTRxREQPopUpModal(event){
    this.openTrnsReqPopup = false;
    this.transferPharmacyNPI = null;
    this.drugId = null;
    this.sourcePharmacyDetails = null;
  }

  handleClick(event: MouseEvent) {
    let target = event.target as HTMLElement | null;
    while (target && target !== document.body) {
      const action = target.getAttribute('data-action');
      if (action === 'initiateTransfer') {
        event.preventDefault();
        const drugId = target.getAttribute('data-drug-id') || '';
        const pharmacyName = target.getAttribute('data-pharmacy-name') || '';
        const pharmacyNPI = target.getAttribute('data-pharmacy-npi') || '';
        this.drugId = drugId;
        this.transferPharmacyNPI = pharmacyNPI;
        this.getInfo();
        this.openTrnsReqPopup = true;
        return;
      }
      target = target.parentElement;
    }
  }

  loadMessages() {
        if(this.resetMessages){
          this.messages = [];
        }        
        const startDateTime = moment('2000-01-01T10:44:50.785Z').format('YYYY-MM-DD') || null;
        const endDateTime = moment().format('YYYY-MM-DD') || null;
        const payLoad: MessagesHistory = {
                Sender: {
                    Identifier: this.npi,
                    IdentifierType: IdentifierTypeEnum.NPI
                },
                Recipient: {
                    Identifier: this.patientID,
                    IdentifierType: IdentifierTypeEnum.PATIENT
                },
                StartDateTime: startDateTime,
                EndDateTime: endDateTime,
                PageIndex: constant.CHAT_PAGE_MIN,
                PageSize: constant.CHAT_PAGE_MAX,
                pharmacyNPI: this.npi
        }; 
        this._msgServ.postMessageConversation(payLoad)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(async (res: any[]) => {
            if (res) {
                let apiMessages = res['communicationLogs'];
                this.fetchedMessages = apiMessages; 
                
                this.fetchedMessages = this.fetchedMessages.filter(apiMessage => 
                    !this.messages.some(existingMessage => 
                        existingMessage.message === apiMessage.message && 
                        existingMessage.date === apiMessage.date
                    )
                );
                this.messages = [...this.fetchedMessages, ...this.messages];
                this.filteredMessages = [...this.messages];
                this.messages.forEach(msg => {
                  if (msg?.sender?.userName) {
                    msg.sender.userName = this.capitalizeName(msg.sender.userName);
                  }
                  msg.status = msg.status?.toLowerCase();
                });
                if (this.messages && this.messages.length > 0) {
                    this.sortMessages();
                    this.groupMessagesByDate();
                    this._ngZone.runOutsideAngular(() => {
                      requestAnimationFrame(() => {
                        this.scrollToBottom();
                      });
                    });
                }
            }
             await this.attachImagesToMessages();
        });
  }
  sortMessages(): void {
    this.messages = this.messages.sort((a, b) => moment(a.date, 'YYYY-MM-DD hh:mm:ss A').diff(moment(b.date, 'YYYY-MM-DD hh:mm:ss A')));
  }

  private capitalizeName(name: string): string {
    return name
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }

  loadPreviousMessages(){
      console.log('Loading previous messages');
  }
  scrollToBottom() {
      const chatHistory = document.querySelector('.chat-history');
      if (chatHistory) {
          chatHistory.scrollTop = chatHistory.scrollHeight;
      }
  }
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    if (this.messageSubscription) {
      this.messageSubscription.unsubscribe();
    }
  }
  extractDocIdsFromMessage(raw: string): string[] {
  if (!raw) return [];
  const hidden = raw.split('~&~')[1]?.trim() || '';
  if (!hidden.startsWith('img:')) return [];
  return hidden.slice(4).split(',').map(s => s.trim()).filter(Boolean);
}

stripUrls(text: string): string {
  return text.replace(/https?:\/\/\S+/g, '').trim();
}


async downloadImagesByIds(docIds: string[]): Promise<Record<string, string>> {
  docIds = docIds ? [...docIds] : [];
  if ((!docIds || docIds.length === 0) && this.ProfilePicDocId) {
    docIds = [this.ProfilePicDocId];
  }
  else if (this.ProfilePicDocId && !docIds.includes(this.ProfilePicDocId)) {
    docIds.unshift(this.ProfilePicDocId);
  }
  if (docIds.length === 0) {
    return {};
  }

  const payload = {
    Pharmacy: {
      IdentifierType: 0,
      Identifier: String(this.npi),
      Name: this.pharmacyName,
    },
    Application: { Id: 1, Name: "Primerx" },
    DocumentIds: docIds,
    RelatedEntity: {
      EntityType: 0,
      Identifier: String(this.patientID),
      Name: this.userName,
    },
    DocumentReference: 2,
     SenderType : 1
  };

  try {
    const resp: any = await this._msgServ.downloadImage(payload).toPromise();
    const map: Record<string, string> = {};
    if (Array.isArray(resp?.documents)) {
      for (const d of resp.documents) {
         const doc = d?.document;
       if (doc?.id) map[doc.id] = doc; 

      }
    }
    if (this.ProfilePicDocId && map[this.ProfilePicDocId]) {
      this.profilePicUrlChange.emit(map[this.ProfilePicDocId]['url']);
    }
    return map;
  } catch {
    return {};
  }
}

async attachImagesToMessages(): Promise<void> {
   this.validDocIds = [];
  this.imageUrlMap = {};
  const allDocIds: string[] = [];
  for (const msg of this.messages) {
    const ids = this.extractDocIdsFromMessage(msg?.message);
    if (ids.length) {
      (msg as any).docIds = ids;
      allDocIds.push(...ids);
    }
  }
  const uniqueDocIds = Array.from(new Set(allDocIds));
   if (uniqueDocIds.length === 0 && this.ProfilePicDocId) {
    uniqueDocIds.push(this.ProfilePicDocId);
  }
  if (!uniqueDocIds.length && !this.ProfilePicDocId) return;
  const idToUrl = await this.downloadImagesByIds(uniqueDocIds);
  this.validDocIds = Object.keys(idToUrl);
  this.imageUrlMap = { ...this.imageUrlMap, ...idToUrl };
  for (const msg of this.messages) {
    const ids: string[] = (msg as any).docIds || [];
    if (ids.length) {
      msg.imageUrls = ids
  .filter(id => this.validDocIds.includes(id)) // <-- Only keep valid images
  .map(id => this.imageUrlMap[id])
  .filter(Boolean);
    }
  }

  const all = this.messages.flatMap(m => (m as any).imageUrls || []);
    const unique = Array.from(new Set(all.filter(Boolean)));
    this.sharedImagesChange.emit(unique);
}

emitSharedImages() {
    const all = this.messages.flatMap(m => (m as any).imageUrls || []);
    const unique = Array.from(new Set(all.filter(Boolean)));
    this.sharedImagesChange.emit(unique);
  }

onImgErr(evt: Event, badUrl: string) {
  const el = evt?.target as HTMLImageElement;
  if (el) el.style.display = 'none';
}

openHistoryPreview(doc: any) {
  this.historyPreviewUrl = doc?.url;
  this.previewDoc = doc;
  this.isHistoryPreviewOpen = true;
  this.previewFilename = doc?.name;
  this.previewDtTm = doc?.creationDateTime;
  this.previewSize = (doc?.sizeInMb)?.toFixed(2) + ' MB';
  this.zoom = 1;  
  document.body.style.overflow = 'hidden';
}

zoomIn(): void {
  if (this.zoomLevel < 300) {
    this.zoomLevel += 10;
    this.zoom = this.zoomLevel / 100;
  }
  const imgEl = document.querySelector('.spc-lightbox__image') as HTMLElement;
  if (imgEl) {
    imgEl.style.transition = 'transform 0.2s ease';
    imgEl.style.transformOrigin = 'center center';
    imgEl.style.transform = `scale(${this.zoom})`;
  }
}

zoomOut(): void {
  if (this.zoomLevel > 10) {
    this.zoomLevel -= 10;
    this.zoom = this.zoomLevel / 100;
  }

  const imgEl = document.querySelector('.spc-lightbox__image') as HTMLElement;
  if (imgEl) {
    imgEl.style.transition = 'transform 0.2s ease';
    imgEl.style.transformOrigin = 'center center';
    imgEl.style.transform = `scale(${this.zoom})`;
  }
}

closeHistoryPreview(): void {
  this.isHistoryPreviewOpen = false;
  this.historyPreviewUrl = null;
  this.previewDrugName = null;
  this.previewFilename = null;
  this.zoom = 1;
  this.zoomLevel = 100;
  document.body.style.overflow = '';
}

 createDocFG() {
  // minimal Document model subset used by uploadNewDocument
 this.docUploadFG = this._fb.group(new Documents());
  this.functionScreen = 'PATIENT';
}

 async getSubCatsForPatient() {
  try {
    const resp: any[] = await this._docService.getDocumentSubCats(this.selectedSaveTo === 'rx' ? { CatId: SharedDocuments.Prescription } : { CatId: SharedDocuments.Patient }).toPromise();
    if (resp) {
      this.subCatDropdowns = resp.filter(x => x.Name !== 'eRx Image' && x.Name !== 'Auto Generated Image');
      this.subCatDropdownsList = [...this.subCatDropdowns];
    }
  } catch { /* ignore */ }
}

async openChatDocModal(imageDoc:any) {
  let rxDefaultSubCat = this._commonServ.DecryptData(localStorage.getItem("rxDefaultSubCat"))
  this.docUploadFG.controls.DocSubCatId.patchValue(parseInt(rxDefaultSubCat));
  this.sizeInBytes = this.getBase64SizeInBytes(imageDoc?.base64EncodedDoc);
   this.getInfo();
this.docUploadFG.reset({
    Name: imageDoc?.name,
    Remarks: '',
    PrintWithLabel: false,
    DocSubCatId: null,
    isRotate: false,
    degree: 360,
    PharmacyNPI: this.npi,
    IsBase64Required: false,
    IsControlFile: false,
  });


  this.formGroupInvalid = false;
  const isPdf = /\.pdf(\?|$)/i.test(imageDoc?.url);
  this.addFileType = isPdf ? 'pdf' : 'image';
  this.src = isPdf ? null : imageDoc?.url;
  this.innerHtml = isPdf ? imageDoc?.url : null;
const byteCharacters = atob(imageDoc.base64EncodedDoc);
const byteNumbers = new Array(byteCharacters.length);
for (let i = 0; i < byteCharacters.length; i++) {
  byteNumbers[i] = byteCharacters.charCodeAt(i);
}
const byteArray = new Uint8Array(byteNumbers);
const file = new File([byteArray], imageDoc?.name, { type: imageDoc?.mimeType });
this.uploadedFile = file;


  this.modalRef = this.modalService.open(this.chatDocTpl, {
    size: 'lg', centered: this.isFrmMessegingTab, keyboard: false, backdrop: 'static', windowClass: this.isFrmMessegingTab ? 'max-modal-75' : 'attachdocuments_chatmodal'
  });
}

saveDocuments() {
  if(this.selectedSaveTo === 'rx' && (!this.selectedRx || this.noRxFound)){
    this.onRxBlur();
  }
    // differentiate based on selectedSaveTo
  if (this.selectedSaveTo === 'rx') {
    this.docUploadFG.patchValue({
      DocCatId: SharedDocuments.Prescription,
      PatientId: null,
      PrescNum: this.selectedRx?.PrescNum || null,
    });
  } else {
    this.docUploadFG.patchValue({
      DocCatId: SharedDocuments.Patient,
      PatientId: this.patientID || null,
      PrescNum: null,
    });
  }
  if (!this.docUploadFG.valid || !this.docUploadFG.value.DocSubCatId) {
    this.formGroupInvalid = true;
    return;
  }
  const fd = new FormData();
  const payload = { ...this.docUploadFG.value };
  payload.PrintWithLabel = !!payload.PrintWithLabel;
  fd.append('DocInputParams', JSON.stringify(payload));
  fd.append('fileKey', this.uploadedFile);
  this._docService.uploadNewDocument(fd,this.sizeInBytes).subscribe({
    next: _ => {
      if (this.selectedSaveTo === 'rx') {
        this._alertService.success(MsgConfig.Doc_Added_to_Rx.replace('{Rx_number}', this.selectedRx?.PrescNum));
      } else {
        this._alertService.success(MsgConfig.Doc_Added_to_Patient.replace('{Pat_name}', this.userName));
      }
      this.saveAuditChange(null);
      this.closeModal();
    },
    error: err => {
      console.error('uploadNewDocument failed', err);
    }
  });
}

closeModal() {
  if (this.modalRef) {
    this.modalRef.close();
    this.modalRef = null;
  }
  this.formGroupInvalid = false;
  this.uploadedFile = null;
  this.addFileType = null;
  this.src = null;
  this.rxQuery = null;
  this.selectedSaveTo = 'patient';
  this.innerHtml = null;
}

editImage() {
  this.showEditImage = true;
}
onEditImageClose(base64: string | null) {
  this.showEditImage = false;
  if (base64) {
    const arr = base64.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    this.uploadedFile = new File([u8arr], 'edited-image.png', { type: mime });
    this.src = base64;
  }
}
getBase64SizeInBytes(base64: string): number {
  if (!base64) return 0;
  const base64Str = base64.includes(',')
    ? base64.split(',')[1]
    : base64;

  const padding = (base64Str.match(/=*$/) || [''])[0].length;
  const sizeInBytes = (base64Str.length * 3) / 4 - padding;
  return sizeInBytes;
}
onSaveToChange(selection: string) {
  this.selectedSaveTo = selection;
  if (selection === 'patient') {
    this.selectedRx = false;
  }
   this.getSubCatsForPatient();


}
onSearch() {
  const query = this.rxQuery?.trim();
  if (!query) {
    this.noRxFound = false; 
    this.selectedRx = false;
    return;
  }

  const payload = {
    PrescNum: query,
    PatientId: this.patientID || null,
  };

  this._patCatServ.getPatientRxDrugDetails(payload).subscribe({
    next: (res: any) => {
      this.rxList = res?.RxDrugs || [];
      this.showDropdown = true;
       this.noRxFound = this.rxList.length === 0;
       this.selectedRx = false;
    },
    error: (err) => {
      console.error('Error fetching Rx list:', err);
    },
  });
}

onSelectRx(rx: any) {
  this.rxQuery = null;
  this.selectedRx = rx;
  this.showDropdown = false;
}
onRxInputChange() {
  const query = this.rxQuery?.trim();
  if (!query) {
    this.noRxFound = false;
    this.selectedRx = false;
    this.rxList = [];
    this.showDropdown = false;
  } else {
    this.noRxFound = false;
  }
}
onRxBlur() {
  const query = this.rxQuery?.trim();
  if (!query) {
    this.noRxFound = true;
    this.selectedRx = false;
    this.rxList = [];
    this.showDropdown = false;
  }
}
downloadImg(imgDoc: any) {
  this._commonUtil.downloadFile(imgDoc);
}

saveAuditChange(originalData: any = null) {
  const type = this.selectedSaveTo === 'rx' ? 'Rx' : 'Patient';
  const entityId = this.selectedSaveTo === 'rx' 
    ? this.selectedRx?.PrescReFillId 
    : this.patientID;

  this.saveAuditDocumentChanges(originalData, entityId, type);
}

saveAuditDocumentChanges(originalData: any, id: any, type: string) {
  const documentModel = [
    { HeaderName: "Name", ControlName: "Name" },
    { HeaderName: "Remarks", ControlName: "Remarks" },
    { HeaderName: "Subcategory", ControlName: "DocSubCatId" }
  ];

  this._NewAuditUtils.saveAuditChange(
    originalData,
    this.docUploadFG.value,
    "Documents",
    type,
    id,
    documentModel,
    false,
    this.subCatDropdownsList
  );
}
hasContent(msg: any): boolean {
  if (!msg) return false;
  const hidden = msg.message?.split('~&~')[1]?.trim() || '';
  if (!hidden.startsWith('img:')) {
    return false;
  }
  const msgDocIds = msg.docIds || [];
  const hasValidImages = msgDocIds.some(id => this.validDocIds.includes(id));
  return hasValidImages;
}
isDeletedMessages(msg: any){
  return this._msgServ.isDeletedMessage(msg);
}
}
